









































































































import Job from "@/store/entities/job";
import { Component, Vue } from "vue-property-decorator";
import OccupationAdd from "./modals/occupationAdd.vue"
import Ajax from '../..//lib/ajax';
import OccupationEdit from "./modals/occupationEdit.vue";
@Component({
  components: { OccupationAdd,OccupationEdit },
})

export default class Occupations extends Vue {
  search: string = "";
  jobs: Job[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  isOpenModal: boolean = false;
  isUpdateModal:boolean=false;
  selectedItem:Job=new Job();


  
  updateJob(item) {
    this.selectedItem=item;
    this.isUpdateModal = true;
  }

    closeUpdateModal() {
    this.isUpdateModal = false;
    this.getJobs();
  }


  
  async created() {
    (this.headers = [
      { text: "Meslek Adı", value: "name" },
      { text: "İşlemler", value: "transactions" },
    ]),

      

    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "Meslekler", disabled: true },
    ];

    await this.getJobs();
  }

  async getJobs(){
    var response = await Ajax.get(
        '/api/services/app/Admin/GetJobs'
      );
      var data = response.data.result.items;
      this.jobs=data;
  }
  confirmDelete(item) {
    this.$swal({
      title: "Kayıt Silinecetir.",
      text: "İşlemi Devam Ettirmeye Emin misiniz?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Evet",
      cancelButtonText: "Hayır",
    }).then(async (result) => {
      if (result.isConfirmed) {
        
       await  Ajax.delete(
        '/api/services/app/Admin/DeleteJob?input=' + item.id
      );

        Vue.$toast.success("Silme Başarılı");

        this.getJobs();
      }
    
    });
  }


  data() {
    return {
      page: 1,
      pageCount: 0,
    
    };
  }
  

  cancelModal() {
    this.isOpenModal = false;

  }


  openModal() {
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
    this.getJobs();
  }



}
